export {};

$(clearFilter);

NLMK.clearFilter = clearFilter;

function clearFilter() {
    $(document).on('click', '.js-clear-filter', function() {
        const $form = $(this).closest('form');

        $form.find('.js-datepicker').each(function(index, element) {
            $(element).data('datepicker').clear();
        });
    });
}



// WEBPACK FOOTER //
// ./js/main/module/clear-filter.js